import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {RxComponent} from '../../../../core/components/common/rx.component';
import {SmartModalService} from '../../../../core/services/smart-modal.service';
import {ConfigService} from '../../../../core/services/config.service';
import {FormBuilder, FormGroup} from '@angular/forms';

declare var $: any;
declare var moment: any;

interface PricingListItemModel {
    id?: string;
    name: string;
    type: any;
    validFrom: any;
    validTill: any;

    region: any;
    accountType: any;
    domain:any;
    customerSegment: any;
    buyerAccount: any;
}

@Component({
  selector: 'itpx-create-new-pricing-list',
  templateUrl: './create-new-pricing-list.component.html',
  styleUrls: ['./create-new-pricing-list.component.css']
})
export class CreateNewPricingListComponent extends RxComponent implements OnInit {

    @Input() data: any;

    private pricingModel: PricingListItemModel;
    private forSeller: any = false;
    private dictionaries: any;
    private initialized: boolean = false;
    private priceListService : any = null;
    private searchSeller: string = null;
    private searchSellerResult: any = null;
    private $showDeleteConfirmation: boolean;

    form: FormGroup;

    private targetGroupAssignmentsOptions = {
        leapestRegions : 'Leapest Region',
        sellerRegions : 'Seller Region',
        buyerGroups : 'Buyer Group',
        buyerSpecific : 'Buyer Specific'
    };

    constructor(
        private cd: ChangeDetectorRef,
        private configService: ConfigService,
        private fb: FormBuilder,
        private modalService: SmartModalService) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            validFrom: [],
            validTill: []
        });
        this.forSeller = this.data.forSeller;
        this.dictionaries = this.data.dictionaries;
        this.priceListService = this.data.priceListService;
        this.pricingModel = this.data.pricingModel ? {...this.data.pricingModel} : {};
        this.removeLeapestRegion();
        this.formatModelData();
        this.$showDeleteConfirmation = false;
    }

    formatModelData() {
        // if (this.pricingModel.validFrom) this.pricingModel.validFrom = Math.abs(new Date(this.pricingModel.validFrom).getTime() / 1000);
        // if (this.pricingModel.validTill) this.pricingModel.validTill = Math.abs(new Date(this.pricingModel.validTill).getTime() / 1000);

        if (this.pricingModel.validFrom) {
            this.form.patchValue({
                validFrom: Math.abs(new Date(this.pricingModel.validFrom).getTime() / 1000)
            })
        }

        if (this.pricingModel.validTill) {
            this.form.patchValue({
                validTill: Math.abs(new Date(this.pricingModel.validTill).getTime() / 1000)
            })
        }

        if (this.pricingModel.id) {
            this.pricingModel.type = this.dictionaries.priceListTypes.filter(_ => _.key === this.pricingModel.type.id)[0];

            this.pricingModel.region =
                this.pricingModel.region &&
                this.dictionaries.regions.filter(_ => _.key === this.pricingModel.region.id)[0];

            this.pricingModel.accountType =
                this.pricingModel.accountType &&
                this.dictionaries.accountTypes.filter(_ => _.key === this.pricingModel.accountType.id)[0];

            //******************************************************
            // Because itpx-combobox requires key property to bind
            //******************************************************
            const domain =
                this.pricingModel.domain &&
                this.dictionaries.domains.filter(_ => _.key === this.pricingModel.domain.id)[0];
            this.pricingModel.domain = domain && domain.key;
            //******************************************************
            // Because itpx-combobox requires key property to bind
            //******************************************************
            const segment =
                this.pricingModel.customerSegment.length ?
                this.dictionaries.accountAccrs.filter(_ => _.key === this.pricingModel.customerSegment[0].id)[0] : null;
            this.pricingModel.customerSegment = segment && segment.key;
            //******************************************************
            // Because itpx-combobox requires key property to bind
            //******************************************************
            const buyer =
                this.pricingModel.buyerAccount.length ?
                this.dictionaries.buyerAccountList.filter(_ => _.key === this.pricingModel.buyerAccount[0].id)[0] : null;
            this.pricingModel.buyerAccount = buyer && buyer.key;
        }
        this.initialized = true;
    }

    isPricingModelValid() {
        const datesAreValid =
            (!this.form.controls.validFrom.value && !this.form.controls.validTill.value) ||
            (this.form.controls.validFrom.value > 0 && this.form.controls.validTill.value > 0 && this.form.controls.validTill.value > this.form.controls.validFrom.value);

        let pricingType = this.pricingModel.type && this.pricingModel.type.value;
        let targetGroupAssignmentValid = false;

        switch (pricingType) {
            case 'Seller Region': {
                targetGroupAssignmentValid = !!(this.pricingModel.region && this.pricingModel.accountType && this.pricingModel.domain);
                break;
            }
            case 'Buyer Group': {
                targetGroupAssignmentValid = !!(this.pricingModel.customerSegment);
                break;
            }
            case 'Buyer Specific': {
                targetGroupAssignmentValid = this.pricingModel.id != null
                    || (!!(this.pricingModel.buyerAccount) && this.isSellerChooseValid());
                break;
            }
        }

        return targetGroupAssignmentValid &&
            datesAreValid &&
            this.pricingModel.name &&
            this.pricingModel.type;
    }

    private isSellerChooseValid() {
        // If admin create or edit pricelist, he has access to all sellers, for seller pricelist we need check that user found seller by identifier without pricelist
        return !this.forSeller || this.searchSellerResult && !this.searchSellerResult.priceListCreated;
    }

    preparePayload() {
        let rawPayload : any = {};
        let validFrom: any = this.form.controls.validFrom.value;
        let validTill: any = this.form.controls.validTill.value;
        rawPayload.id = this.pricingModel.id;
        rawPayload.name = this.pricingModel.name;
        rawPayload.type = {id: this.pricingModel.type.key};
        rawPayload.validFrom = validFrom ? moment(new Date(validFrom * 1000)).format('YYYY-MM-DD[T]HH:mm:ss') : null;
        rawPayload.validTill = validTill ? moment(new Date(validTill * 1000)).format('YYYY-MM-DD[T]HH:mm:ss') : null;

        rawPayload.deleteOperation = this.$showDeleteConfirmation;

        let pricingType = this.pricingModel.type && this.pricingModel.type.value;

        switch (pricingType) {
            case 'Seller Region': {
                rawPayload.region = {id: this.pricingModel.region.key};
                rawPayload.accountType = {id: this.pricingModel.accountType.key};
                rawPayload.domain = {id: this.pricingModel.domain};
                break;
            }
            case 'Buyer Group': {
                rawPayload.customerSegment = [{configKey: this.pricingModel.customerSegment}];
                break;
            }
            case 'Buyer Specific': {
                rawPayload.buyerAccount = [{id: this.pricingModel.buyerAccount}];
                if (rawPayload.id) {
                    rawPayload.buyerAccount = this.data.pricingModel.buyerAccount;
                }
                break;
            }
        }
        return rawPayload;
    }

    savePricing() {
        this.modalService.sendResult(this.preparePayload());
    }

    searchSellerById(searchBy) {
        this.searchSellerResult = null;
        this.priceListService.searchSellerById(this.searchSeller).subscribe(_ => {

            this.searchSellerResult = _ || -1;
            this.pricingModel.buyerAccount = this.searchSellerResult && this.searchSellerResult.id || null;
        });
    }

    removeLeapestRegion() {
        this.dictionaries.priceListTypes = this.dictionaries.priceListTypes.filter(_ => _.value !== 'Leapest Region');
    }

    showDeleteConfirmation() {
        this.$showDeleteConfirmation = true;
    }

    hideDeleteConfirmation() {
        this.$showDeleteConfirmation = false;
    }

    deletePricelist() {
        this.modalService.sendResult(this.preparePayload());
    }

    isDeletePriceListAvailable() {
        return this.pricingModel.id && this.pricingModel.type != null && this.pricingModel.type != undefined && 'Leapest Region' != this.pricingModel.type.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pricing/create-new-pricing-list/create-new-pricing-list.component.ts